import styled from 'styled-components';

export const ResourcesFilterBarInstructionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;

  padding: 20px 0px;
`;

export const ResourcesFilterBarInstructionsTitle = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourcesFilterBarInstructionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 33px;
`;

export const ResourcesFilterBarInstructionsParagraph = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: #000;
`;

interface ResourcesFilterBarInstructionsItemProps {
  clickable?: boolean;
}

export const ResourcesFilterBarInstructionsItem = styled.div<ResourcesFilterBarInstructionsItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  padding: 5px 10px;

  ${({ clickable }) =>
    clickable &&
    `
      cursor: pointer;
      border-radius: 20px;
      background: rgba(255, 255, 255, 0.50);
      box-shadow: 5px 0 20px -10px rgba(50, 63, 93, 0.10);
  `}
`;

export const ResourcesFilterBarInstructionsItemIcon = styled.div`
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  border: 1px solid var(--color-primary);
`;

export const ResourcesFilterBarInstructionsInformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ResourcesFilterBarInstructionsInformationTitle = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;

  color: var(--color-text);
`;

export const ResourcesFilterBarInstructionsInformationDescription = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: var(--color-text);
`;

export const ResourcesFilterBarInstructionsInformationDescriptionUnderline = styled.span`
  text-decoration: underline;

  cursor: pointer;
`;
